import ActiveOrder from "../ActiveOrder";
import SectionItem from "./sectionItem";
import ShiftsSummary from "../ShiftsSummary";
import ShiftsHistorySummary from "../ShiftsHistorySummary";
import ShiftsHistoryTripSummary from "../ShiftsHistoryTripSummary";
import HistoryFooter from "../HistoryFooter/HistoryFooter";

const components = {
  activeOrder: ActiveOrder,
  shiftsSummary: ShiftsSummary,
  shiftsHistorySummary: ShiftsHistorySummary,
  shiftsHistoryTripSummary: ShiftsHistoryTripSummary,
  historyFooter: HistoryFooter,
  default: SectionItem
};

export default function getSectionComponent(tag) {
  return components[tag || "default"];
}
